export default __webpack_public_path__ + "static/media/Ballroll_00338.9c847217.png";